<template>
  <div class="page-content">
    <span class="all-data"
      >共 <i>{{ dataTotal }}</i> 条数据</span
    >
    <el-button
      class="page-btn first-page"
      :class="currentPage == 1 ? 'first' : ''"
      :disabled="currentPage == 1"
      @click="frontpage"
      >首页</el-button
    >
    <el-pagination
      layout="prev, pager, next"
      :total="dataTotal"
      :page-size="pagesize"
      :current-page="currentPage"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>
    <el-button
      class="page-btn"
      :class="currentPage == totalpage ? 'last' : ''"
      :disabled="currentPage == totalpage"
      @click="lastpage"
      >尾页</el-button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
    };
  },
  props: {
    dataTotal: Number,
    totalpage:{
      type:Number,
      default:10
    },
    pagesize:{
      type:Number,
      default:10
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit('changePage',this.currentPage)
    },
    frontpage(){
      this.currentPage = 1
      this.$emit('changePage',this.currentPage)
    },
    lastpage(){
      this.currentPage = this.totalpage
      this.$emit('changePage',this.currentPage)
    }
  },
};
</script>

<style scoped lang="less">
.page-content {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  span {
    line-height: 26px;
    padding: 2px 5px;
    font-size: 14px;
  }
  span.all-data {
    color: #333333;
    i {
      color: #478aff;
    }
  }
  button.first-page {
    color: #333333;
    padding-left: 20px;
  }
  button.first {
    color: #999999;
  }
  button.last {
    color: #999999;
  }
  .page-btn {
    border: none;
    padding: 0 6px;
    color: #333333;
    background-color: #ffffff;
  }
  .page-btn:hover {
    background-color: #ffffff !important;
  }
  /deep/ .el-pagination .btn-next {
    color: #333333;
  }
  /deep/ .el-pagination button:disabled {
    color: #999999;
  }
  .btn-next {
    color: #333333;
  }
}
</style>